<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Fichas de Contenido</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
             <div class="col-md-3">
              <ResourceSearchs :routeApi="'contentsheet'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
      <ValidationObserver ref="formValidation">
       <div class="modal-body">
         <b-row>
           <b-col>
              <div>
                <label for="">Nombre</label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                    id="NOMBRE"
                    v-model="selectedItem.NOMBRE"
                    placeholder="Nombre..." />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <br />
              <div>
                Tipo tratamiento - Intento 1 <select class="form-control" v-model="selectedItem.TIPO_TRATAMIENTO_FICHA1">
                  <option value="0">Sin tratamiento</option>
                  <option value="1">Visualizar el concepto</option>
                  <option value="2">Ficha de contenido de asociada</option>
                  <option value="3">Visualizar el resultado</option>
                </select>
              </div>
              <div>
                Tipo tratamiento - Intento 2 <select class="form-control" v-model="selectedItem.TIPO_TRATAMIENTO_FICHA2">
                  <option value="0">Sin tratamiento</option>
                  <option value="1">Visualizar el concepto</option>
                  <option value="2">Ficha de contenido de asociada</option>
                  <option value="3">Visualizar el resultado</option>
                </select>
              </div>
              <div>
                Tipo tratamiento - Intento 3 <select class="form-control" v-model="selectedItem.TIPO_TRATAMIENTO_FICHA3">
                  <option value="0">Sin tratamiento</option>
                  <option value="1">Visualizar el concepto</option>
                  <option value="2">Ficha de contenido de asociada</option>
                  <option value="3">Visualizar el resultado</option>
                </select>
              </div>
              <br/>
              <div>
                Concepto asociado
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger"
                    v-if="selectedItem.CONCEPTOS_ID !== null && selectedItem.CONCEPTOS_ID !== 0" @click="cleanConcept()"/>
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                      v-if="selectedItem.CONCEPTOS_ID !== null && selectedItem.CONCEPTOS_ID !== 0"
                      @click="openResourceWithParam('concepts', selectedItem.CONCEPTOS_ID)"/>
                  <input type="text" v-model="selectedItem.text.CONCEPTO_NOMBRE" disabled class="form-control" />
                  <searchconcepts class="p-2" idModal="mdlSearchConcept"
                    v-on:selected="onSelectedConcept($event)">
                  </searchconcepts>
                </div>
              </div>
              <div>
                Ficha de tratamiento
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger"
                    v-if="selectedItem.CONTENIDOS_ID_TRATAMIENTO !== null && selectedItem.CONTENIDOS_ID_TRATAMIENTO !== 0" @click="cleanContentsheet()"/>
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                      v-if="selectedItem.CONTENIDOS_ID_TRATAMIENTO !== null && selectedItem.CONTENIDOS_ID_TRATAMIENTO !== 0"
                      @click="openResourceWithParam('contentsheets', selectedItem.CONTENIDOS_ID_TRATAMIENTO)"/>
                  <input type="text" v-model="selectedItem.text.CONTENIDOS_TRATAMIENTO" disabled class="form-control" />
                  <searchsheets class="p-2" idModal="mdlSearchSheet"
                    v-on:selected="onSelectedSheet($event)">
                  </searchsheets>
                </div>
              </div>
            </b-col>
            <b-col>
                <div>
                  Distribución <select class="form-control" v-model="selectedItem.DISTRIBUCION">
                    <option value="1">Texto + respuestas</option>
                    <option value="2">Imagen + respuestas</option>
                    <option value="3">Texto + imagen + respuestas</option>
                    <option value="4">Imagen + texto + respuestas</option>
                    <option value="5">Imagen y texto + respuestas</option>
                  </select>
                </div>
                <br />
                <div>
                  <label>Texto Enunciado</label>
                  <ValidationProvider
                    :rules="{required: parseInt(selectedItem.DISTRIBUCION) !== 2}"
                    v-slot="{ errors }">
                    <div class="col-md-12 d-inline-flex align-items-center">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTO_ID_ENUNCIADO !== null && selectedItem.TEXTO_ID_ENUNCIADO !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTO_ID_ENUNCIADO)"/>
                      <b-form-textarea
                        id="TEXTO_ENUNCIADO"
                        disabled class="form-control"
                        v-bind:value="getTranslation(selectedItem.text.TEXTO_ENUNCIADO)"
                        placeholder="Texto..."
                        rows="3"
                        max-rows="6" />
                      <searchtexts class="pl-2" idModal="mdlSearchTextEnunciado"
                        v-on:selected="onSelectedTextEnunciado($event)">
                      </searchtexts>
                    </div>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <br />
                <div>
                  <label>Audio Enunciado</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0" @click="cleanAudio()"/>
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0"
                        @click="openResourceWithParam('audios', selectedItem.AUDIOS_ID)"/>
                    <audio :src="getTranslation(selectedItem.text.AUDIO_ENUNCIADO)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0">
                    </audio>
                    <span v-if="selectedItem.AUDIOS_ID === null || selectedItem.AUDIOS_ID === 0">Sin audio</span>
                    <searchaudios class="pl-2" idModal="mdlSearchAudio"
                      v-on:selected="onSelectedAudio($event)">
                    </searchaudios>
                  </div>
                </div>
                <br />
                <div>
                  <label>Imagen Enunciado</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger"
                      v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0" @click="cleanImage()"/>
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                        @click="openResourceWithParam('images', selectedItem.IMAGENES_ID)"/>
                    <div class="image">
                        <img :src="getTranslation(selectedItem.text.IMAGEN_ENUNCIADO)" alt="img"
                        style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <div class="font-italic" v-if="selectedItem.IMAGENES_ID === null || selectedItem.IMAGENES_ID === 0">
                        Sin imagen
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageEnunciado"
                      v-on:selected="onSelectedImageEnunciado($event)">
                    </searchimages>
                  </div>
                </div>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col md="3">
                <div>
                  Tipo respuesta <select class="form-control" v-model="selectedItem.TIPO_RESPUESTA">
                    <option value="A">Tipo test</option>
                    <option value="B">Si/No</option>
                    <option value="C">Respuesta abierta</option>
                    <option value="D">Imágenes</option>
                    <option value="E">Sin respuesta/Exposición</option>
                  </select>
                </div>
              </b-col>
              <b-col md="3">
                <div>
                  Numero de intentos <select class="form-control" v-model="selectedItem.NUM_INTENTOS_FICHA">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </div>
              </b-col>
              <b-col md="3" v-if="selectedItem.TIPO_RESPUESTA==='A' || selectedItem.TIPO_RESPUESTA==='B' || selectedItem.TIPO_RESPUESTA==='D'">
                <div>
                  Opción correcta <select class="form-control" v-model="selectedItem.CORRECTO">
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C" v-if="selectedItem.TIPO_RESPUESTA!=='B'">C</option>
                    <option value="D" v-if="selectedItem.TIPO_RESPUESTA!=='B'">D</option>
                    <option value="E" v-if="selectedItem.TIPO_RESPUESTA!=='B'">E</option>
                  </select>
                </div>
              </b-col>
              <b-col md="4" v-if="selectedItem.TIPO_RESPUESTA==='C'">
                <br />
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="verbaloral" v-model="selectedItem.EDITOR_FORMULAS">
                  <label class="custom-control-label" for="verbaloral">
                  Mostrar editor de Formulas</label>
                </div>
              </b-col>
            </b-row>
            <br />
            <b-row>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='A' || selectedItem.TIPO_RESPUESTA==='B'">
                  <label>Respuesta A</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="(selectedItem.TEXTOS_ID_OPC_A !== null && selectedItem.TEXTOS_ID_OPC_A !== 0)" @click="cleanTextResponse(0)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTO_OPC_A)" disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextResponseA" bButtonIcon="true"
                      v-on:selected="onSelectedTextResponse($event, 0)">
                    </searchtexts>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='A' || selectedItem.TIPO_RESPUESTA==='B'">
                  <label>Respuesta B</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="(selectedItem.TEXTOS_ID_OPC_B !== null && selectedItem.TEXTOS_ID_OPC_B !== 0)" @click="cleanTextResponse(1)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTO_OPC_B)" disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextResponseB" bButtonIcon="true"
                      v-on:selected="onSelectedTextResponse($event, 1)">
                    </searchtexts>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='A'">
                  <label>Respuesta C</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="(selectedItem.TEXTOS_ID_OPC_C!== null && selectedItem.TEXTOS_ID_OPC_C !== 0)" @click="cleanTextResponse(2)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTO_OPC_C)" disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextResponseC" bButtonIcon="true"
                      v-on:selected="onSelectedTextResponse($event, 2)">
                    </searchtexts>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='A'">
                  <label>Respuesta D</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="(selectedItem.TEXTOS_ID_OPC_D !== null && selectedItem.TEXTOS_ID_OPC_D !== 0)" @click="cleanTextResponse(3)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTO_OPC_D)" disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextResponseD" bButtonIcon="true"
                      v-on:selected="onSelectedTextResponse($event, 3)">
                    </searchtexts>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='A'">
                  <label>Respuesta E</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="(selectedItem.TEXTOS_ID_OPC_E !== null && selectedItem.TEXTOS_ID_OPC_E !== 0)" @click="cleanTextResponse(4)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTO_OPC_E)" disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextResponseE" bButtonIcon="true"
                      v-on:selected="onSelectedTextResponse($event, 4)">
                    </searchtexts>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='D'">
                  <label>Respuesta A</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID_OPC_A !== null" @click="cleanImageResponse(1)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.responses.IMAGENES_OPC_A)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageResponseA" bButtonIcon="true"
                      v-on:selected="onSelectedImageResponse($event, 0)">
                    </searchimages>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='D'">
                  <label>Respuesta B</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID_OPC_B !== null" @click="cleanImageResponse(2)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.responses.IMAGENES_OPC_B)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageResponseB" bButtonIcon="true"
                      v-on:selected="onSelectedImageResponse($event, 1)">
                    </searchimages>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='D'">
                  <label>Respuesta C</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID_OPC_C !== null" @click="cleanImageResponse(3)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.responses.IMAGENES_OPC_C)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageResponseC" bButtonIcon="true"
                      v-on:selected="onSelectedImageResponse($event, 2)">
                    </searchimages>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='D'">
                  <label>Respuesta D</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID_OPC_D !== null" @click="cleanImageResponse(4)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.responses.IMAGENES_OPC_D)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageResponseD" bButtonIcon="true"
                      v-on:selected="onSelectedImageResponse($event, 3)">
                    </searchimages>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='D'">
                  <label>Respuesta E</label><i class="pl-2 zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID_OPC_E !== null" @click="cleanImageResponse(5)"/>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.responses.IMAGENES_OPC_E)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImageResponseE" bButtonIcon="true"
                      v-on:selected="onSelectedImageResponse($event, 4)">
                    </searchimages>
                  </div>
                </div>
                <div class="col" v-if="selectedItem.TIPO_RESPUESTA==='C'">
                  Respuesta correcta
                  <ValidationProvider rules="required|max:120" v-slot="{ errors }">
                    <b-form-input v-model="selectedItem.CORRECTO"
                      type="text">
                    </b-form-input>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
            </b-row>
          <br />
          <label for="Tag">
          <br>
            Etiquetas</label>
              <div>
              <vue-tags-input
                v-model="tag"
                :tags="tags"
                :autocomplete-items="autocompleteItems"
                @tags-changed="update"
              />
            </div>
          <div class="modal-footer">
            <button type="button" @click="save"
            class="btn btn-info btn-round waves-effect">
              Guardar</button>
            <b-button class="btn btn-default btn-round waves-effect" block
            @click="$bvModal.hide('info-modal')">Cerrar</b-button>
          </div>
      </div>
    </ValidationObserver>
  </b-modal>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import searchaudios from '../audios/SearchAudios.vue';
import searchconcepts from '../concepts/SearchConcepts.vue';
import searchsheets from './SearchSheets.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('max', {
  ...max,
  message: 'Máximo 120 caracteres.',
});

export default {
  components: {
    VueTagsInput,
    searchtexts,
    searchimages,
    searchaudios,
    searchconcepts,
    searchsheets,
    ValidationProvider,
    ValidationObserver,
    ResourceSearchs,
  },
  name: 'gridContentsheets',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      currentPage: 1,
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'TIPO_RESPUESTA', label: 'Tipo respuesta' },
        { key: 'DISTRIBUCION', label: 'Distribución' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: '', // Nombre descriptivo para buscar
        TIPO_RESPUESTA: 'A', // [A] tipo test [B] si/no o verdadero/falso [C] respuesta abierta [D] Imágenes [E] sin respuesta-exposición
        CORRECTO: null, // Opción correcta en caso de seleccionar una opcion (Tipos A,B y D) o respuesta en caso de respuesta abierta ( C)
        TEXTO_ID_ENUNCIADO: null, // Enlace al enunciado de la ficha
        AUDIOS_ID: null, // Enlace al audio de la ficha, 0 sino tiene audio
        IMAGENES_ID: null, // Enlace a imagen de la ficha, 0 sino tiene imagen
        TEXTOS_ID_OPC_A: null, // Enlace al texto de la opción como respuesta (Tipos A y B)
        TEXTOS_ID_OPC_B: null, // Enlace al texto de la opción como respuesta (Tipos A y B)
        TEXTOS_ID_OPC_C: null, // Enlace al texto de la opción como respuesta (Tipos A)
        TEXTOS_ID_OPC_D: null, // Enlace al texto de la opción como respuesta (Tipos A)
        TEXTOS_ID_OPC_E: null, // Enlace al texto de la opción como respuesta (Tipos A)
        IMAGENES_ID_OPC_A: null, // Enlace a la imagen opción como respuesta (Tipos D)
        IMAGENES_ID_OPC_B: null, // Enlace a la imagen opción como respuesta (Tipos D)
        IMAGENES_ID_OPC_C: null, // Enlace a la imagen opción como respuesta (Tipos D)
        IMAGENES_ID_OPC_D: null, // Enlace a la imagen opción como respuesta (Tipos D)
        IMAGENES_ID_OPC_E: null, // Enlace a la imagen opción como respuesta (Tipos D)
        DISTRIBUCION: 1, // La ficha de contenido puede tener varias distribuciones: (1) texto + respuestas (2) imagen + respuestas (3) texto + imagen +  respuestas (4) imagen + texto + respuestas  (5) imagen y texto + respuestas
        TIPO_TRATAMIENTO_FICHA1: 0, // En el primer intento: (0) Sin tratamiento (1) Visualizar el concepto (2) Ficha de contenido de asociada (3) Visualizar el resultado.
        TIPO_TRATAMIENTO_FICHA2: 0, // En el primer intento: (0) Sin tratamiento (1) Visualizar el concepto (2) Ficha de contenido de asociada (3) Visualizar el resultado.
        TIPO_TRATAMIENTO_FICHA3: 0, // En el primer intento: (0) Sin tratamiento (1) Visualizar el concepto (2) Ficha de contenido de asociada (3) Visualizar el resultado.
        EDITOR_FORMULAS: false,
        CONTENIDOS_ID_TRATAMIENTO: null, // Enlace a la ficha de tratamiento
        NUM_INTENTOS_FICHA: 3, // Número de intentos para resolver la ficha
        CONCEPTOS_ID: null, // Concepto asociado a la ficha
        text: { // Used for display
          TEXTO_ENUNCIADO: [],
          AUDIO_ENUNCIADO: [],
          IMAGEN_ENUNCIADO: [],
          CONTENIDOS_TRATAMIENTO: null,
          CONCEPTO_NOMBRE: null,
        },
        responses: { // Used for display
          TEXTO_OPC_A: [],
          TEXTO_OPC_B: [],
          TEXTO_OPC_C: [],
          TEXTO_OPC_D: [],
          TEXTO_OPC_E: [],
          IMAGENES_OPC_A: [],
          IMAGENES_OPC_B: [],
          IMAGENES_OPC_C: [],
          IMAGENES_OPC_D: [],
          IMAGENES_OPC_E: [],
        },
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      tags: [],
      newTags: [],
      tagslist: [],
      newTags2: [],
      taglist: '',
      autocompleteItems: [],
    };
  },
  methods: {
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedTextEnunciado(itemSelected) {
      this.selectedItem.TEXTO_ID_ENUNCIADO = itemSelected.ID;
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.setTranslation('TEXTO_', itemSelected, this.selectedItem.text.TEXTO_ENUNCIADO);
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextEnunciado');
    },
    /**
    * @method cleanTextResponse
    * @description Limpia la opcion
    */
    cleanTextResponse(id) {
      switch (id) {
        case 0:
          this.selectedItem.TEXTOS_ID_OPC_A = null;
          this.selectedItem.responses.TEXTO_OPC_A = [];
          break;
        case 1:
          this.selectedItem.TEXTOS_ID_OPC_B = null;
          this.selectedItem.responses.TEXTO_OPC_B = [];
          break;
        case 2:
          this.selectedItem.TEXTOS_ID_OPC_C = null;
          this.selectedItem.responses.TEXTO_OPC_C = [];
          break;
        case 3:
          this.selectedItem.TEXTOS_ID_OPC_D = null;
          this.selectedItem.responses.TEXTO_OPC_D = [];
          break;
        case 4:
          this.selectedItem.TEXTOS_ID_OPC_E = null;
          this.selectedItem.responses.TEXTO_OPC_E = [];
          break;
        default:
          break;
      }
    },
    onSelectedTextResponse(itemSelected, id) {
      switch (id) {
        case 0:
          this.selectedItem.TEXTOS_ID_OPC_A = itemSelected.ID;
          this.selectedItem.responses.TEXTO_OPC_A = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTO_OPC_A);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponseA');
          break;
        case 1:
          this.selectedItem.TEXTOS_ID_OPC_B = itemSelected.ID;
          this.selectedItem.responses.TEXTO_OPC_B = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTO_OPC_B);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponseB');
          break;
        case 2:
          this.selectedItem.TEXTOS_ID_OPC_C = itemSelected.ID;
          this.selectedItem.responses.TEXTO_OPC_C = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTO_OPC_C);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponseC');
          break;
        case 3:
          this.selectedItem.TEXTOS_ID_OPC_D = itemSelected.ID;
          this.selectedItem.responses.TEXTO_OPC_D = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTO_OPC_D);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponseD');
          break;
        case 4:
          this.selectedItem.TEXTOS_ID_OPC_E = itemSelected.ID;
          this.selectedItem.responses.TEXTO_OPC_E = [];
          this.setTranslation('TEXTO_', itemSelected, this.selectedItem.responses.TEXTO_OPC_E);
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponseE');
          break;
        default:
          break;
      }
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse');
    },
    /**
    * @method cleanAudio
    * @description Limpia el audio
    */
    cleanAudio() {
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar un audio
    */
    onSelectedAudio(itemSelected) {
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.AUDIO_ENUNCIADO);
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudio');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanImage() {
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
    },
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImageEnunciado(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImageEnunciado');
    },
    /**
    * @method cleanImageResponse
    * @description Limpia la opcion
    */
    cleanImageResponse(id) {
      switch (id) {
        case 0:
          this.selectedItem.IMAGENES_ID_OPC_A = null;
          this.selectedItem.responses.IMAGENES_OPC_A = [];
          break;
        case 1:
          this.selectedItem.IMAGENES_ID_OPC_B = null;
          this.selectedItem.responses.IMAGENES_OPC_B = [];
          break;
        case 2:
          this.selectedItem.IMAGENES_ID_OPC_C = null;
          this.selectedItem.responses.IMAGENES_OPC_C = [];
          break;
        case 3:
          this.selectedItem.IMAGENES_ID_OPC_D = null;
          this.selectedItem.responses.IMAGENES_OPC_D = [];
          break;
        case 4:
          this.selectedItem.IMAGENES_ID_OPC_E = null;
          this.selectedItem.responses.IMAGENES_OPC_E = [];
          break;
        default:
          break;
      }
    },
    onSelectedImageResponse(itemSelected, id) {
      switch (id) {
        case 0:
          this.selectedItem.IMAGENES_ID_OPC_A = itemSelected.ID;
          this.selectedItem.responses.IMAGENES_OPC_A = [];
          this.setTranslation('FICHERO_', itemSelected, this.selectedItem.responses.IMAGENES_OPC_A);
          this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponseA');
          break;
        case 1:
          this.selectedItem.IMAGENES_ID_OPC_B = itemSelected.ID;
          this.selectedItem.responses.IMAGENES_OPC_B = [];
          this.setTranslation('FICHERO_', itemSelected, this.selectedItem.responses.IMAGENES_OPC_B);
          this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponseB');
          break;
        case 2:
          this.selectedItem.IMAGENES_ID_OPC_C = itemSelected.ID;
          this.selectedItem.responses.IMAGENES_OPC_C = [];
          this.setTranslation('FICHERO_', itemSelected, this.selectedItem.responses.IMAGENES_OPC_C);
          this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponseC');
          break;
        case 3:
          this.selectedItem.IMAGENES_ID_OPC_D = itemSelected.ID;
          this.selectedItem.responses.IMAGENES_OPC_D = [];
          this.setTranslation('FICHERO_', itemSelected, this.selectedItem.responses.IMAGENES_OPC_D);
          this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponseD');
          break;
        case 4:
          this.selectedItem.IMAGENES_ID_OPC_E = itemSelected.ID;
          this.selectedItem.responses.IMAGENES_OPC_E = [];
          this.setTranslation('FICHERO_', itemSelected, this.selectedItem.responses.IMAGENES_OPC_E);
          this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponseE');
          break;
        default:
          break;
      }
      this.$root.$emit('bv::hide::modal', 'mdlSearchImageResponse');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanConcept() {
      this.selectedItem.CONCEPTOS_ID = null;
      this.selectedItem.text.CONCEPTO_NOMBRE = null;
    },
    /**
    * @method onSelectedConcept
    * @description Al seleccionar un concepto
    */
    onSelectedConcept(itemSelected) {
      this.selectedItem.CONCEPTOS_ID = itemSelected.ID;
      this.selectedItem.text.CONCEPTO_NOMBRE = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', 'mdlSearchConcept');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanContentsheet() {
      this.selectedItem.CONTENIDOS_ID_TRATAMIENTO = null;
      this.selectedItem.text.CONTENIDOS_TRATAMIENTO = null;
    },
    /**
    * @method onSelectedSheet
    * @description Al seleccionar un ficha de contenido
    */
    onSelectedSheet(itemSelected) {
      this.selectedItem.CONTENIDOS_ID_TRATAMIENTO = itemSelected.ID;
      this.selectedItem.text.CONTENIDOS_TRATAMIENTO = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', 'mdlSearchSheet');
    },
    onNew() {
      this.limpiar();
      this.infoModal.title = 'Nueva Ficha';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TIPO_RESPUESTA = 'A';
      this.selectedItem.CORRECTO = 'A';
      this.selectedItem.TEXTO_ID_ENUNCIADO = null;
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.TEXTOS_ID_OPC_A = null;
      this.selectedItem.TEXTOS_ID_OPC_B = null;
      this.selectedItem.TEXTOS_ID_OPC_C = null;
      this.selectedItem.TEXTOS_ID_OPC_D = null;
      this.selectedItem.TEXTOS_ID_OPC_E = null;
      this.selectedItem.responses.TEXTO_OPC_A = [];
      this.selectedItem.responses.TEXTO_OPC_B = [];
      this.selectedItem.responses.TEXTO_OPC_C = [];
      this.selectedItem.responses.TEXTO_OPC_D = [];
      this.selectedItem.responses.TEXTO_OPC_E = [];
      this.selectedItem.IMAGENES_ID_OPC_A = null;
      this.selectedItem.IMAGENES_ID_OPC_B = null;
      this.selectedItem.IMAGENES_ID_OPC_C = null;
      this.selectedItem.IMAGENES_ID_OPC_D = null;
      this.selectedItem.IMAGENES_ID_OPC_E = null;
      this.selectedItem.DISTRIBUCION = 1;
      this.selectedItem.TIPO_TRATAMIENTO_FICHA1 = 0;
      this.selectedItem.TIPO_TRATAMIENTO_FICHA2 = 0;
      this.selectedItem.TIPO_TRATAMIENTO_FICHA3 = 0;
      this.selectedItem.EDITOR_FORMULAS = false;
      this.selectedItem.CONTENIDOS_ID_TRATAMIENTO = null;
      this.selectedItem.NUM_INTENTOS_FICHA = 3;
      this.selectedItem.CONCEPTOS_ID = null;
      // Text to show on forms
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.text.CONTENIDOS_TRATAMIENTO = null;
      this.selectedItem.text.CONCEPTO_NOMBRE = null;
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagscontentsheet/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('contentsheet/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.infoModal.title = 'Editar Ficha';

      this.loading = true;
      try {
        const response = await this.axios.get('contentsheet/getcontent', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el contenido', { type: 'warning' });
      }
      this.loading = false;
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.$refs.formValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }

        this.loading = true;
        const unitData = {
          ID: this.selectedItem.ID || -1,
          NOMBRE: this.selectedItem.NOMBRE,
          TIPO_RESPUESTA: this.selectedItem.TIPO_RESPUESTA,
          CORRECTO: this.selectedItem.CORRECTO,
          TEXTO_ID_ENUNCIADO: this.selectedItem.TEXTO_ID_ENUNCIADO,
          AUDIOS_ID: this.selectedItem.AUDIOS_ID,
          IMAGENES_ID: this.selectedItem.IMAGENES_ID,
          TEXTOS_ID_OPC_A: this.selectedItem.TEXTOS_ID_OPC_A,
          TEXTOS_ID_OPC_B: this.selectedItem.TEXTOS_ID_OPC_B,
          TEXTOS_ID_OPC_C: this.selectedItem.TEXTOS_ID_OPC_C,
          TEXTOS_ID_OPC_D: this.selectedItem.TEXTOS_ID_OPC_D,
          TEXTOS_ID_OPC_E: this.selectedItem.TEXTOS_ID_OPC_E,
          IMAGENES_ID_OPC_A: this.selectedItem.IMAGENES_ID_OPC_A,
          IMAGENES_ID_OPC_B: this.selectedItem.IMAGENES_ID_OPC_B,
          IMAGENES_ID_OPC_C: this.selectedItem.IMAGENES_ID_OPC_C,
          IMAGENES_ID_OPC_D: this.selectedItem.IMAGENES_ID_OPC_D,
          IMAGENES_ID_OPC_E: this.selectedItem.IMAGENES_ID_OPC_E,
          DISTRIBUCION: this.selectedItem.DISTRIBUCION,
          TIPO_TRATAMIENTO_FICHA1: this.selectedItem.TIPO_TRATAMIENTO_FICHA1,
          TIPO_TRATAMIENTO_FICHA2: this.selectedItem.TIPO_TRATAMIENTO_FICHA2,
          TIPO_TRATAMIENTO_FICHA3: this.selectedItem.TIPO_TRATAMIENTO_FICHA3,
          EDITOR_FORMULAS: this.selectedItem.EDITOR_FORMULAS,
          CONTENIDOS_ID_TRATAMIENTO: this.selectedItem.CONTENIDOS_ID_TRATAMIENTO,
          NUM_INTENTOS_FICHA: this.selectedItem.NUM_INTENTOS_FICHA,
          CONCEPTOS_ID: this.selectedItem.CONCEPTOS_ID,
        };

        try {
          const response = await this.axios.post('contentsheet/store', unitData);
          if (response.data.status === 'success') {
            const bc = new BroadcastChannel('new_resource_contentsheet');
            bc.postMessage({
              ID: response.data.id,
              NOMBRE: this.selectedItem.NOMBRE,
              TIPO_RESPUESTA: this.selectedItem.TIPO_RESPUESTA,
            });

            const url = `Tagscontentsheet/deleteTags/${response.data.id}`;
            const url2 = 'Tagscontentsheet/saveTag';

            this.axios.get(url);
            this.newTags.forEach((a) => {
              this.axios.get(`Tags/findTagByName/${a.text}`,
                { name: a.text }).then((resp) => {
                if (resp.data.status === 'success') {
                  this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
                } else {
                  this.axios.post(url2, { id: a.key, idtexto: response.data.id });
                }
              });
            });

            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();

            // Auto close if coming from a create event
            if (this.bAutoClose) {
              window.open('', '_self').close();
            }

            this.getPostData();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        } catch (e) {
          const resp = e;
          if (!resp.body.Ok) {
            this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        }
      });
    },
    async getContents() {
      this.loading = true;

      try {
        const response = await this.axios.get('contentsheet');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('contentsheet', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagscontentsheet/findByContentsheet/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_contentsheet_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    // Get params Id for edit
    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
